var _rect, _rect2, _rect3, _rect4, _g, _g2, _g3, _rect5, _rect6, _rect7, _rect8, _g4, _g5, _g6, _g7, _rect9, _rect0, _rect1, _g8, _g9, _g0, _g1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 676,
    height: 410,
    viewBox: "0 0 676 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.9952,
    height: 179.995,
    transform: "matrix(0.86601 0.500028 3.18351e-05 1 341.014 0.613281)",
    fill: "#6E6E6E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 49.9952,
    height: 179.995,
    transform: "matrix(0.86601 -0.500028 -3.18351e-05 1 297.718 25.6123)",
    fill: "#5A5A5A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 49.9952,
    height: 49.9952,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 341.014 180.606)",
    fill: "#AAAAAA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 136.232,
    height: 136.232,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 221.539 200.531)",
    fill: "#EDE7F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.9952,
    height: 179.623,
    transform: "matrix(0.86601 0.500028 3.18351e-05 1 297.719 24.8174)",
    fill: "#B39DDB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.9952,
    height: 179.623,
    transform: "matrix(0.86601 0.500028 3.18351e-05 1 297.719 24.8174)",
    fill: "url(#paint0_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.9952,
    height: 179.995,
    transform: "matrix(0.86601 -0.500028 -3.18351e-05 1 341.014 50.603)",
    fill: "#B39DDB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.9952,
    height: 179.995,
    transform: "matrix(0.86601 -0.500028 -3.18351e-05 1 341.014 50.603)",
    fill: "url(#paint1_linear)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.9952,
    height: 49.9952,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 297.717 25.6089)",
    fill: "url(#paint2_linear)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 37.7876,
    height: 37.7876,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 308.289 25.6089)",
    fill: "#EDE7F6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 89.9976,
    transform: "matrix(0.86601 0.500028 3.18351e-05 1 286.637 108.199)",
    fill: "#6E6E6E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 89.9976,
    transform: "matrix(0.86601 -0.500028 -3.18351e-05 1 264.989 120.699)",
    fill: "#5A5A5A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 24.9976,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 286.637 198.195)",
    fill: "#AAAAAA"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 89.9976,
    transform: "matrix(0.86601 0.500028 3.18351e-05 1 264.988 120.695)",
    fill: "url(#paint3_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 89.9976,
    transform: "matrix(0.86601 -0.500028 -3.18351e-05 1 286.637 133.194)",
    fill: "url(#paint4_linear)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 24.9976,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 264.988 120.697)",
    fill: "url(#paint5_linear)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3047,
    height: 18.3047,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 270.785 120.695)",
    fill: "#E3F2FD"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 89.9976,
    transform: "matrix(0.86601 0.500028 3.18351e-05 1 405.961 114.447)",
    fill: "#6E6E6E"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 89.9976,
    transform: "matrix(0.86601 -0.500028 -3.18351e-05 1 384.313 126.947)",
    fill: "#5A5A5A"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 24.9976,
    transform: "matrix(0.866041 0.499972 -0.866041 0.499972 405.961 204.443)",
    fill: "#AAAAAA"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 89.9976,
    transform: "matrix(0.86601 0.500028 3.18351e-05 1 384.312 126.943)",
    fill: "url(#paint6_linear)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 89.9976,
    transform: "matrix(0.86601 -0.500028 -3.18351e-05 1 405.961 139.442)",
    fill: "url(#paint7_linear)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9976,
    height: 24.9976,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 384.312 126.945)",
    fill: "url(#paint8_linear)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3047,
    height: 18.3047,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 390.109 126.943)",
    fill: "#E3F2FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 233.719,
    y: 24.8174,
    width: 171.302,
    height: 352.622,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.227451 0 0 0 0 0.717647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 277.009,
    y: 25.604,
    width: 171.302,
    height: 352.994,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.227451 0 0 0 0 0.717647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 233.717,
    y: 0.612793,
    width: 214.596,
    height: 197.992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.227451 0 0 0 0 0.717647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 200.988,
    y: 120.695,
    width: 149.651,
    height: 250.497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 222.634,
    y: 120.695,
    width: 149.651,
    height: 250.497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 200.988,
    y: 108.199,
    width: 171.298,
    height: 172.996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 206.785,
    y: 111.543,
    width: 159.705,
    height: 166.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 320.312,
    y: 126.943,
    width: 149.651,
    height: 250.497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 341.958,
    y: 126.943,
    width: 149.651,
    height: 250.497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d",
    x: 320.312,
    y: 114.447,
    width: 171.298,
    height: 172.996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d",
    x: 326.109,
    y: 117.792,
    width: 159.705,
    height: 166.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50.0065,
    y1: -126.416,
    x2: 22.7813,
    y2: 178.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -0.0124691,
    y1: -162.854,
    x2: 28.6155,
    y2: 30.7094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 48.2212,
    y1: 11.3137,
    x2: -2.84767,
    y2: 24.0142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A491C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C5F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 7.05895,
    y1: 132.528,
    x2: 61.7277,
    y2: 107.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 7.05895,
    y1: 132.528,
    x2: 61.7277,
    y2: 107.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 7.05895,
    y1: 36.8107,
    x2: 24.8496,
    y2: 7.48566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 7.05895,
    y1: 132.528,
    x2: 61.7277,
    y2: 107.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 7.05895,
    y1: 132.528,
    x2: 61.7277,
    y2: 107.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 7.05895,
    y1: 36.8107,
    x2: 24.8496,
    y2: 7.48566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBuild);
export default __webpack_public_path__ + "static/media/img-build.48884e64b3131d80cdc695bd54b37762.svg";
export { ForwardRef as ReactComponent };